var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigmaQuickAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_3563_4107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 10.5C20 4.975 15.525 0.5 10 0.5C4.475 0.5 0 4.975 0 10.5C0 16.025 4.475 20.5 10 20.5C15.525 20.5 20 16.025 20 10.5Z",
    fill: "#E7D6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0129 8.4748C14.5379 7.9623 14.8629 7.2498 14.8629 6.44981C14.8629 4.88731 13.5879 3.6123 12.0254 3.6123H7.98789C6.42539 3.6123 5.15039 4.88731 5.15039 6.44981C5.15039 7.2373 5.47539 7.9498 6.00039 8.4748C5.47539 8.9873 5.15039 9.6998 5.15039 10.4998C5.15039 11.2998 5.47539 11.9998 6.00039 12.5248C5.47539 13.0373 5.15039 13.7498 5.15039 14.5498C5.15039 16.1123 6.42539 17.3873 7.98789 17.3873C9.55039 17.3873 10.8254 16.1123 10.8254 14.5498V13.0748C11.1879 13.2498 11.6004 13.3498 12.0254 13.3498C13.5879 13.3498 14.8629 12.0748 14.8629 10.5123C14.8629 9.72481 14.5379 9.0123 14.0129 8.4873V8.4748Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.97422 16.5627C9.08672 16.5627 9.99922 15.6627 9.99922 14.5377V12.5127H7.97422C6.86172 12.5127 5.94922 13.4127 5.94922 14.5377C5.94922 15.6627 6.84922 16.5627 7.97422 16.5627Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.97461 16.7876C6.73711 16.7876 5.72461 15.7751 5.72461 14.5376C5.72461 13.3001 6.73711 12.2876 7.97461 12.2876H10.2246V14.5376C10.2246 15.7751 9.21211 16.7876 7.97461 16.7876ZM7.97461 12.7501C6.98711 12.7501 6.18711 13.5501 6.18711 14.5376C6.18711 15.5251 6.98711 16.3251 7.97461 16.3251C8.96211 16.3251 9.76211 15.5251 9.76211 14.5376V12.7501H7.97461Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.96289 10.5001C5.96289 9.3876 6.86289 8.4751 7.98789 8.4751H10.0129V12.5126H7.98789C6.87539 12.5126 5.96289 11.6126 5.96289 10.4876V10.5001Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.2246 12.75H7.97461C6.73711 12.75 5.72461 11.7375 5.72461 10.5C5.72461 9.2625 6.73711 8.25 7.97461 8.25H10.2246V12.7375V12.75ZM7.97461 8.7125C6.98711 8.7125 6.18711 9.5125 6.18711 10.5C6.18711 11.4875 6.98711 12.2875 7.97461 12.2875H9.76211V8.7H7.97461V8.7125Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.96289 6.4625C5.96289 5.35 6.86289 4.4375 7.98789 4.4375H10.0129V8.475H7.98789C6.87539 8.475 5.96289 7.575 5.96289 6.45V6.4625Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.2246 8.7124H7.97461C6.73711 8.7124 5.72461 7.6999 5.72461 6.4624C5.72461 5.2249 6.73711 4.2124 7.97461 4.2124H10.2246V8.6999V8.7124ZM7.97461 4.6624C6.98711 4.6624 6.18711 5.4624 6.18711 6.4499C6.18711 7.4374 6.98711 8.2374 7.97461 8.2374H9.76211V4.6499H7.97461V4.6624Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10 4.4375H12.025C13.1375 4.4375 14.05 5.3375 14.05 6.4625C14.05 7.5875 13.15 8.4875 12.025 8.4875H10V4.45V4.4375Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.0254 8.7126H9.77539V4.2251H12.0254C13.2629 4.2251 14.2754 5.2376 14.2754 6.4751C14.2754 7.7126 13.2629 8.7251 12.0254 8.7251V8.7126ZM10.2254 8.2501H12.0129C13.0004 8.2501 13.8004 7.4501 13.8004 6.4626C13.8004 5.4751 13.0004 4.6751 12.0129 4.6751H10.2254V8.2626V8.2501Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.0383 10.5001C14.0383 11.6126 13.1383 12.5251 12.0133 12.5251C10.8883 12.5251 9.98828 11.6251 9.98828 10.5001C9.98828 9.3751 10.8883 8.4751 12.0133 8.4751C13.1383 8.4751 14.0383 9.3751 14.0383 10.5001Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.0254 12.75C10.7879 12.75 9.77539 11.7375 9.77539 10.5C9.77539 9.2625 10.7879 8.25 12.0254 8.25C13.2629 8.25 14.2754 9.2625 14.2754 10.5C14.2754 11.7375 13.2629 12.75 12.0254 12.75ZM12.0254 8.7125C11.0379 8.7125 10.2379 9.5125 10.2379 10.5C10.2379 11.4875 11.0379 12.2875 12.0254 12.2875C13.0129 12.2875 13.8129 11.4875 13.8129 10.5C13.8129 9.5125 13.0129 8.7125 12.0254 8.7125Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M7.97422 16.5627C9.08672 16.5627 9.99922 15.6627 9.99922 14.5377V12.5127H7.97422C6.86172 12.5127 5.94922 13.4127 5.94922 14.5377C5.94922 15.6627 6.84922 16.5627 7.97422 16.5627Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M7.97461 16.7876C6.73711 16.7876 5.72461 15.7751 5.72461 14.5376C5.72461 13.3001 6.73711 12.2876 7.97461 12.2876H10.2246V14.5376C10.2246 15.7751 9.21211 16.7876 7.97461 16.7876ZM7.97461 12.7501C6.98711 12.7501 6.18711 13.5501 6.18711 14.5376C6.18711 15.5251 6.98711 16.3251 7.97461 16.3251C8.96211 16.3251 9.76211 15.5251 9.76211 14.5376V12.7501H7.97461Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M5.96289 10.5001C5.96289 9.3876 6.86289 8.4751 7.98789 8.4751H10.0129V12.5126H7.98789C6.87539 12.5126 5.96289 11.6126 5.96289 10.4876V10.5001Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M10.2246 12.75H7.97461C6.73711 12.75 5.72461 11.7375 5.72461 10.5C5.72461 9.2625 6.73711 8.25 7.97461 8.25H10.2246V12.7375V12.75ZM7.97461 8.7125C6.98711 8.7125 6.18711 9.5125 6.18711 10.5C6.18711 11.4875 6.98711 12.2875 7.97461 12.2875H9.76211V8.7H7.97461V8.7125Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M5.96289 6.4625C5.96289 5.35 6.86289 4.4375 7.98789 4.4375H10.0129V8.475H7.98789C6.87539 8.475 5.96289 7.575 5.96289 6.45V6.4625Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M10.2246 8.7124H7.97461C6.73711 8.7124 5.72461 7.6999 5.72461 6.4624C5.72461 5.2249 6.73711 4.2124 7.97461 4.2124H10.2246V8.6999V8.7124ZM7.97461 4.6624C6.98711 4.6624 6.18711 5.4624 6.18711 6.4499C6.18711 7.4374 6.98711 8.2374 7.97461 8.2374H9.76211V4.6499H7.97461V4.6624Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M10 4.4375H12.025C13.1375 4.4375 14.05 5.3375 14.05 6.4625C14.05 7.5875 13.15 8.4875 12.025 8.4875H10V4.45V4.4375Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12.0254 8.7126H9.77539V4.2251H12.0254C13.2629 4.2251 14.2754 5.2376 14.2754 6.4751C14.2754 7.7126 13.2629 8.7251 12.0254 8.7251V8.7126ZM10.2254 8.2501H12.0129C13.0004 8.2501 13.8004 7.4501 13.8004 6.4626C13.8004 5.4751 13.0004 4.6751 12.0129 4.6751H10.2254V8.2626V8.2501Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M14.0383 10.5001C14.0383 11.6126 13.1383 12.5251 12.0133 12.5251C10.8883 12.5251 9.98828 11.6251 9.98828 10.5001C9.98828 9.3751 10.8883 8.4751 12.0133 8.4751C13.1383 8.4751 14.0383 9.3751 14.0383 10.5001Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M12.0254 12.75C10.7879 12.75 9.77539 11.7375 9.77539 10.5C9.77539 9.2625 10.7879 8.25 12.0254 8.25C13.2629 8.25 14.2754 9.2625 14.2754 10.5C14.2754 11.7375 13.2629 12.75 12.0254 12.75ZM12.0254 8.7125C11.0379 8.7125 10.2379 9.5125 10.2379 10.5C10.2379 11.4875 11.0379 12.2875 12.0254 12.2875C13.0129 12.2875 13.8129 11.4875 13.8129 10.5C13.8129 9.5125 13.0129 8.7125 12.0254 8.7125Z",
    fill: "#171923"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3563_4107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaQuickAction);
export default __webpack_public_path__ + "static/media/FigmaQuickAction.c0e4e60f813ff2553e59c631218e758c.svg";
export { ForwardRef as ReactComponent };